import { render, staticRenderFns } from "./OnlinePassengersBookedToday.vue?vue&type=template&id=99363e74"
import script from "./OnlinePassengersBookedToday.vue?vue&type=script&lang=js"
export * from "./OnlinePassengersBookedToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports